/* eslint-disable react/prop-types */
import classes from './Frame.module.scss' ;
import { Link } from "react-router-dom";
import img from '../assets/ehealth.png'
// import {menus} from './SliderData' ;
// import {useState} from 'react'

// const menus = [
//     {title : 'Our Mission' , content : 'MILLENSYS mission is Improving the quality of people’s lives through timely introduction of high quality and cost effective integrated solutions in healthcare and business IT solutions. insuring the maximum success to our partners and maximizing our profits for the benefits of our shareholders.'},
//     {title : 'Our Vision' , content : 'MILLENSYS Vision is to be a global market leader in innovative , high quality and cost effective healthcare , medical imaging and commercial software IT solutions in its targeted markets. MILLENSYS shall be highly committed to its customers and targeted markets by insuring the delivery of innovative solutions, cost effective and high quality integrated services through its high qualified and well trained staff. MILLENSYS shall work with its maximum efforts to present continuously updated information technology to better serve its customers in its targeted markets.'},
//     {title : 'Our Goals' , content : 'Providing a unique unified healthcare management information platform to manage a whole healthcare ecosystem from a single place Develop brand awareness and acceptance for our product line around the globe Maintaining a positive and strong growth each year. Achieving a stable market share increase with a market penetration strategy in some markets and Diversification in others. Continue to develop MILLENSYS image as the leader in innovative solutions provider in medical IT and beyond.'},
//     {title : 'Our Values' , content : 'Focusing on customer needs.Developing our people. Delivering on commitments. Continuous Innovations.'},
// ]

// const Card = ({title , overview  })=>{
//     const [isOpen,setIsOpen] = useState(false);
//     const onClickHndler =()=>{
//         setIsOpen(prev => !prev )
//     }
//     return(
//         <article className={`${classes.fque} ${isOpen && classes.open} `}>
//         <div className={classes["f__icon"]} onClick={onClickHndler} >{!isOpen? `+` : "-"}</div>
//         <div className={classes["f__answer"]}>
//             <h4>{title}</h4>
//             <p>{overview}</p>
//         </div>
//     </article>
//     )
// }


function Frame() {
    const content = `The Only Unified Solution to run a professional healthcare organizations`
    return (
        <section className={`${classes["section__container"]} `}>
        <p className={classes["section__subheader"]}>MIlLENSYS, Modular Enterprise Healthcare Platform</p>
        <p className={classes["__strong"]}>
            {content}
        </p>
        <div className={`${classes["container"]} `}>
            <img src={img} alt="img" className='img-fluid' loading="lazy"/>
        </div>
        <button className={classes["product___btn"]}>
            <Link to={'/products/1'}>Read More</Link>
        </button>
    </section>
    )
}

export default Frame
